<template>
  <v-container fluid grid-list-lg>
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    ></Create>
    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editYear="selectedYear"
    ></Edit>
    <v-card :loading="loading" outlined>
      <ListTitle
        :showBackButton="true"
        :access="checkRightStatus(33)"
        title="Year"
        @add="add"
      />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            rounded
            dense
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="years"
        :search="search"
        :loading="loading"
        :sort-by="sortBy"
        :page.sync="page"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-left">{{ item.name }}</td>
            <td class="text-left">
              <!-- Check if Class exists before trying to access its name -->
              {{ item.Class ? item.Class.name : 'No Department' }}
            </td>
            <td class="text-left">{{ item.note ? item.note : '' }}</td> 
            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item
                    v-if="checkRightStatus(35)"
                    @click="editYear(item)"
                  >
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="checkRightStatus(36)"
                    @click="deleteYear(item)"
                  >
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import yearService from "../service";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");
export default {
  name: "year-list",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedYear: null,
      headers: [
        {
          text: "Title",
          align: "left",
          value: "name",
          sortable: true,
        },
        {text: "Department",
          align: "left",
          value: "Class.name", // Points to the 'name' property in the 'Class' object
          sortable: true,
        },
        {
          text: "Notes",
          value: "notes",
          sortable: true,
        },
        {
          text: "Action",
          value: "action",
          width: '60',
          sortable: false,
        },
      ],
      years: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "createdAt",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Year List";
  },
  components: {
    Create,
    Edit,
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false 
      this.createDialog = false
      return yearService.getAll().then((response) => {
        console.log('response', response)
        this.loading = false;
        this.years = response.data;
        return response;
      });
    },
    editYear(year) {
      this.selectedYear = year;
      this.editDialog = !this.editDialog;
    },
    deleteYear(year) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          yearService.delete(year.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Year has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
